export default function (t) {
  return [
    { title: t('general.code'), field: 'id' },
    { title: t('general.name'), field: 'name' },
    { title: t('school-grade.education-stage'), field: 'educationStage.name' },
    { title: t('general.order'), field: 'order' },
    { title: t('general.active'), field: 'activeDescription' },
  ];
}
